import { CustomMarker } from './custom-marker.model';

export class MapMarkers {
  public allMarkers: CustomMarker[] = [];
  public areaMarkers?: CustomMarker[] = [];
  public totalMatchesCount?: number = 0;

  public constructor(allMarkers: CustomMarker[] = [], areaMarkers: CustomMarker[] = [], totalMatchesCount = 0) {
    this.allMarkers = allMarkers;
    this.areaMarkers = areaMarkers;
    this.totalMatchesCount = totalMatchesCount;
  }

  public markerExists(id: string): boolean {
    return this.allMarkers.some((marker) => marker.id === id);
  }
}
